/* import __COLOCATED_TEMPLATE__ from './subscription-type-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();